// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__b_4i5","notes":"Notes_notes__P57Z_","note":"Notes_note__eEi4E","markdown":"Notes_markdown__3jgVu"};